import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  createReward,
  fetchRewardList,
  deleteReward,
  updateReward,
  fetchConditionList
} from '../../modules/reward'

import {
  Tooltip,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Avatar,
  Tag
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'
import RewardForm from './components/RewardForm'
import { REWARD_TYPE } from '../../utils/constants'

const Reward = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')

  const { rewardItem, condition, isLoading } = useSelector(
    (state) => ({
      rewardItem: state.reward.rewardList,
      condition: state.reward.condition,
      isLoading: state.reward.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchRewardList())
      await dispatch(fetchConditionList())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => { }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(fetchRewardList())
    await setVisible(false)
  }

  const onDelete = async (id) => {
    await dispatch(deleteReward(id))
    await dispatch(fetchRewardList())
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateReward(data))
    } else {
      await dispatch(createReward(data))
    }

    await dispatch(fetchRewardList())
    await setVisible(false)
    await setFormData({})
  }
  const columns = [
    {
      title: 'ชื่อรางวัล',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'รางวัล',
      dataIndex: 'image',
      key: 'image',
      render: (image) => (
        <div>
          <Avatar key={image} src={image} size={43} />
        </div>
      )
    },
    {
      title: 'รายละเอียด',
      dataIndex: 'detail',
      key: 'detail',
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 150,
          }
        }
      },
      width: '30%',
      ...getColumnSearchProps('detail'),
      render: (detail) => (
        <Tooltip title={detail}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{detail}</div>
        </Tooltip>
      )
    },
    {
      title: 'คะแนนที่ใช้แลก',
      dataIndex: 'redeemPoint',
      key: 'redeemPoint',
      ...getColumnSearchProps('redeemPoint')
    },
    {
      title: 'รางวัลคงเหลือ',
      dataIndex: 'availableAmount',
      key: 'availableAmount',
    },
    {
      title: 'ประเภทรางวัล',
      dataIndex: 'catagories',
      key: 'catagories',
    },
    {
      title: 'ชนิด',
      dataIndex: 'rewardType',
      key: 'rewardType',
      render: (value) =>
        value === REWARD_TYPE.COUPON.value ? (
          <Tag color="gold">{REWARD_TYPE.COUPON.label}</Tag>
        ) : (
          <Tag>{REWARD_TYPE.PRODUCT.label}</Tag>
        )
    },
    {
      title: 'เงื่อนไข',
      dataIndex: 'scopeRuleTexts',
      key: 'scopeRuleTexts',
      render: (texts) => {
        if (!texts || texts.length === 0) {
          return 'ไม่จำกัด'
        }
        return (
          <Tooltip title={texts.join(' หรือ ')}>
            <Tag color="blue">{texts.length + ' เงื่อนไข'}</Tag>
          </Tooltip>
        )
      }
    },
    {
      title: 'จำนวนสูงสุดต่อคน',
      dataIndex: 'maxRedeemPerUser',
      key: 'maxRedeemPerUser',
      render: (value) => {
        if (value == null) return 'ไม่จำกัด'
        if (Number(value) === 0) return <Tag color="red">ปิดการแลกชั่วคราว</Tag>
        return value
      }
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Card
      title="Reward"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            Create Reward
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Table
        loading={isLoading}
        scroll={{ x: 1300 }}
        rowKey={(record) => record.id}
        dataSource={rewardItem}
        columns={columns}
      />
      <RewardForm
        visible={visible}
        onOk={onOk}
        condition={condition}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}


Reward.propTypes = {
  data: PropTypes.object.isRequired,
  DeleteReward: PropTypes.func.isRequired,
  CreateReward: PropTypes.func.isRequired,
  UpdateReward: PropTypes.func.isRequired
}

export default compose(
  withApollo
)(Reward)
